import { combineReducers } from 'redux';

import globalReducer from '../../pages/reducers';

const rootReducer = combineReducers({ globalReducer });

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
